import { connect } from 'react-redux';
import AuctionDetail from 'components/auctions/AuctionDetail';
import {
  clearImages,
  clearAuctionBids,
  fetchImages,
  fetchAuction,
  startAuctions,
  commentAuction,
  endAuction,
  cancelAuctions,
  createAuctionBids,
  fetchBidsForAuction,
  acceptAuction,
  rejectAuction,
  fetchComments,
  fetchParts,
} from 'data/auctions/Auctions.actions';
import { cancelBid } from 'data/bids/Bids.actions';
import { fetchAuctionParty } from 'data/parties/Parties.actions';
import { showAlert } from 'data/app/App.actions';
import ReduxHelper from 'lib/ReduxHelper';
import { PartyTypes } from 'vdlib';

const mapStateToProps = state => {
  return ReduxHelper.mapStateWithLookups(
    {
      lang: state.i18n.locale,
      auction: state.auctions.currentAuction,
      bids: state.auctions.currentAuctionBids,
      comments: state.auctions.currentAuctionComments,
      creatingAuctionBidsFor: state.auctions.creatingAuctionBidsFor,
      parts: state.auctions.currentAuctionParts,
      fetchingImages: state.auctions.fetchingImages,
      fetchingInsurance: state.parties.fetchingCurrentInsurance,
      fetchingMerchant: state.parties.fetchingCurrentMerchant,
      insuranceData: state.parties.currentInsurance,
      images: state.auctions.images,
      loading:
        state.auctions.fetchingCurrentAuction ||
        state.auctions.fetchingCurrentAuctionBids,
      merchantData: state.parties.currentMerchant,
      message: state.auctions.message || {},
      submitting:
        state.auctions.startingAuctions ||
        state.auctions.endingAuction ||
        state.auctions.acceptingAuction ||
        state.auctions.dispatchingAuction ||
        state.auctions.rejectingAuction ||
        state.auctions.cancellingAuctions ||
        state.auctions.creatingAuctionBids ||
        state.auctions.commentingAuction ||
        state.bids.cancelingBid,
      user: state.app.user,
      merchantFees: state.app.merchantFees,
    },
    state,
    'auctionStatuses',
    'bidStatuses',
    'fuelTypes',
    'vehicleTypes',
    'gearBoxes',
    'wheelDrives',
    'partyTypes',
    'regions',
    'taxOffices',
    'countries',
    'bidFileTypes',
    'cancellationReasons',
    'applications',
    'memberships'
  );
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const auctionId = parseInt(ownProps.params.id);
  return {
    createBid: (auctionId, bidData, partyId) =>
      dispatch(createAuctionBids(auctionId, bidData, partyId)),
    cancelBid: bidId => dispatch(cancelBid(bidId)),
    fetchAuction: forceRefresh => {
      dispatch(fetchAuction(auctionId, forceRefresh));
      dispatch(fetchImages(auctionId));
    },
    fetchBids: () => dispatch(fetchBidsForAuction(auctionId)),
    fetchComments: () => dispatch(fetchComments(auctionId)),
    fetchParts: () => dispatch(fetchParts(auctionId)),
    startAuction: (auctionData, comments) =>
      dispatch(startAuctions([auctionData], comments)),
    commentAuction: (auctionId, auctionStatusId, comments) =>
      dispatch(commentAuction(auctionId, auctionStatusId, comments)),
    endAuction: (bidId, ownerInfo) => dispatch(endAuction(bidId, ownerInfo)),
    acceptAuction: () => dispatch(acceptAuction(auctionId)),
    rejectAuction: comments => dispatch(rejectAuction(auctionId, comments)),
    cancelAuction: () => dispatch(cancelAuctions([auctionId])),
    cancelAuctionWithReason: (auctionId, reason) =>
      dispatch(cancelAuctions([auctionId], reason)),

    fetchMerchant: merchantId =>
      dispatch(fetchAuctionParty(merchantId, PartyTypes.Merchant)),
    fetchInsurance: insuranceId =>
      dispatch(fetchAuctionParty(insuranceId, PartyTypes.Insurance)),

    fetchImages: () => dispatch(fetchImages(auctionId)),

    showAlert: (text, type, duration) => showAlert(text, type, duration),

    clearData: () => {
      dispatch(clearAuctionBids());
      dispatch(clearImages());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AuctionDetail);
